<article class="ai-report">
  <div class="ai-report-head">
    <h2 class="ai-report-title">{{ report().title }}</h2>
    @if (report().summary) {
      <p class="ai-report-summary">{{ report().summary }}</p>
    }
  </div>
  @for (section of report().sections; track $index) {
    <section class="ai-report-section" [attr.data-tone]="section.tone">
      <h3 class="ai-report-heading">{{ section.heading }}</h3>
      @for (paragraph of section.paragraphs; track $index) {
        <p class="ai-report-paragraph">{{ paragraph }}</p>
      }
      @if (section.bullets.length) {
        <ul class="ai-report-bullets">
          @for (bullet of section.bullets; track $index) {
            <li>{{ bullet }}</li>
          }
        </ul>
      }
    </section>
  }
</article>
